export const scrollToTranscriptCard = (index: number) => {
  const cardWrapper = document.querySelector(`div[data-ref="transcript-cards"]`);

  if (cardWrapper) {
    const card = cardWrapper.querySelector(`[data-ref="transcript-speaker-card-${index}"`);
    if (card) {
      cardWrapper.scrollTo({
        top: card.getBoundingClientRect().top + cardWrapper.scrollTop - cardWrapper.getBoundingClientRect().top,
        behavior: 'smooth',
      });
    }
  }
};
